/* istanbul ignore file */

export class SessionExpiryConstants {

    static LOGOUT = 'logout';
    static EXTEND = 'extend';

}
